import script from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=2b3a2947&scoped=true&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3a2947"]])

export default __exports__